import { createContext, useContext, useState, useCallback } from "react";
import api, { setAccessToken } from "../api/axios";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    setAccessToken(data.accessToken);
    setUser(data.user);
    return data.user;
  }, []);

  const signup = useCallback(
    async ({ firstName, lastName, email, password }) => {
      const { data } = await api.post("/api/auth/signup", {
        firstName,
        lastName,
        email,
        password,
      });
      setAccessToken(data.accessToken);
      setUser(data.user);
      return data.user;
    },
    []
  );

  const googleLogin = useCallback(async (credential) => {
    const { data } = await api.post("/api/auth/google", { credential });
    setAccessToken(data.accessToken);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/api/auth/logout");
    } finally {
      setAccessToken(null);
      setUser(null);
    }
  }, []);

  const bootstrap = useCallback(async () => {
    try {
      const { data } = await api.post("/api/auth/refresh");
      setAccessToken(data.accessToken);
      if (data.user) setUser(data.user);
      else {
        const me = await api.get("/api/auth/me");
        setUser(me.data.user);
      }
    } catch {
      setAccessToken(null);
      setUser(null);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, login, signup, googleLogin, logout, bootstrap }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
};